export type ReleaseStageType = 'alpha' | 'closed_beta' | 'public_beta' | 'ga';
export type PermissionType = 'read' | 'write';

export class KaizenLabService {
  public label: string;
  public name: string;
  public description: string;
  public url: string;
  public releaseStage: ReleaseStageType;
  public available: boolean;
  public permissions: PermissionType[];

  constructor({
    label,
    name,
    description,
    url,
    releaseStage,
    available,
    permissions,
  }: {
    label: string;
    name: string;
    description: string;
    url: string;
    releaseStage: ReleaseStageType;
    available: boolean;
    permissions: PermissionType[];
  }) {
    this.label = label;
    this.name = name;
    this.description = description;
    this.url = url;
    this.releaseStage = releaseStage;
    this.available = available;
    this.permissions = permissions;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/domain/entity/KaizenLabService.ts